export default __webpack_public_path__ + "static/media/maria-vasconcelos-title.39696869.png";